import URLConst from '../constants/URLConst';
import { fetchJSON, securePUT } from '../utilities/FetchHelper';

class TermsAndConditionsService {

    putTermsAndConditions(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_TERMS_AND_CONDITIONS
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }

        const formData = data.formData
        let putData = {
            ...formData
        }
        return fetchJSON(url, { ...securePUT(), body: JSON.stringify(putData) }).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }
}

export default new TermsAndConditionsService();